import type { IAssistantLeftNotificationData } from "@frontend-shared/types";
import { UserMinus } from "lucide-react";
import { memo, useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";

interface IAssistantLeftCardProps {
  uuid: string;
  data: IAssistantLeftNotificationData;
  createdAt: string;
  isRead: boolean;
  onViewAssistants: (projectUuid: string) => void;
}

const AssistantLeftCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
  onViewAssistants,
}: IAssistantLeftCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  const handleViewAssistants = useCallback(
    () => onViewAssistants(data.projectUuid),
    [onViewAssistants, data.projectUuid],
  );

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="assistant_left"
      createdAt={createdAt}
      isRead={isRead}
      icon={<UserMinus className="h-5 w-5 text-slate-500" />}
      iconBgClassName="bg-slate-500/10"
      ctaLabel={t("view_assistants")}
      onCtaClick={handleViewAssistants}
      body={
        <Trans
          ns="notifications"
          i18nKey="type.assistant_left.body"
          values={{
            leftUserName: data.leftUserName,
            assistantName: data.assistantName,
          }}
          components={{ b: <strong /> }}
        />
      }
    />
  );
};

export const AssistantLeftCard = memo(AssistantLeftCardComponent);
